<template lang="pug">
    div(class="test")
        div(class="stock-card-item stn-sdw" style="height:445px;")
            //- div(class="stock-card-item-title")
            //-     div(class="fade-out-and-fade-in-1" style="height:20px; width:60px; background-color:lightgrey; border:0px solid;")
            //-     div(class="fade-out-and-fade-in-1" style="height:20px; width:100px; background-color:lightgrey; border:0px solid;")
            //-     div(class="fade-out-and-fade-in-1 text-right" style="height:20px; width:60px; background-color:lightgrey; border:0px solid;")

            //- div(class="stock-card-item-content")

            //-     div(class="item-data" style="display: flex; padding: 24px 0")

            //-         div(style="padding-right: 12px; width:100%;")
            //-             div(class="fade-out-and-fade-in-1" style="height:20px; background-color:lightgrey; border:0px solid;")
            //-             div(class="fade-out-and-fade-in-1 mt-2" style="height:70px; background-color:lightgrey; border:0px solid;")

            //-         div(class="fade-out-and-fade-in-1" style="width:120px; background-color:lightgrey; border:0px solid;")

            //- div(class="item-stock-data")
            //-     div(class="fade-out-and-fade-in-1" style="height:20px; background-color:lightgrey; border:0px solid;")

            //-     div(class="mt-2" style="width:100%; border:0 solid;")
            //-         div(class="fade-out-and-fade-in-1" style="height:170px; background-color:lightgrey; border:0px solid;")

            //-     div(class="fade-out-and-fade-in-1 mt-4 mb-2" style="height:20px; background-color:lightgrey; border:0px solid;")
</template>

<script>
export default {
    name: 'SkeletonStockCard'
}
</script>

<style scoped>
.stock-card-item {
    background-color:#fff;
    border: 0px solid green;
    border-radius: 8px;
    margin:8px;
    padding: 12px;
}

.stock-card-item-title {
    align-items: center;
    display: flex;
    justify-content: space-between;
}

.fade-out-and-fade-in-1 {
    animation: fade-out-fade-in 2s infinite;
}

.fade-out-and-fade-in-2 {
    animation: fade-out-fade-in 2.2s infinite;
}

.fade-out-and-fade-in-3 {
    animation: fade-out-fade-in 2.4s infinite;
}

.fade-out-and-fade-in-4 {
    animation: fade-out-fade-in 2.6s infinite;
}

.fade-out-and-fade-in-5 {
    animation: fade-out-fade-in 2.8s infinite;
}

.fade-out-and-fade-in-6 {
    animation: fade-out-fade-in 3s infinite;
}

@keyframes fade-out-fade-in {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}
</style>
